import { IActionNavItem, IHrefNavItem, IMenuNavItem } from '@web_opxp/components';
import { AuthActions } from '@web_opxp/features';
import { LanguageService } from '@web_opxp/language';
import { HistoryService } from 'web_core_library';
import ENV from '../../base/env';

const LogoutItem: IActionNavItem = {
  kind: 'action',
  label: 'common:Header.Menu.Logout',
  action: AuthActions.logout.type,
};

const UserSettingsItem: IHrefNavItem = {
  kind: 'href',
  label: 'common:Header.Menu.Profile',
  // link is empty while it will be rewritten in menu generation function
  link: '',
};

const personalizationItem: IHrefNavItem = {
  kind: 'href',
  label: 'common:Header.Menu.Personalization',
  // link is relative path to feature on corresponding domain
  link: '/settings',
};

const FriendsItem: IHrefNavItem = {
  kind: 'href',
  label: 'common:Header.Menu.Friends',
  // link is empty while it will be rewritten in menu generation function
  link: '',
};

const MessagesItem: IHrefNavItem = {
  kind: 'href',
  label: 'common:Header.Menu.Messages',
  // link is empty while it will be rewritten in menu generation function
  link: '',
};

export function getUserMenu(
  actionHandler: (actionType: string) => void,
  language: string,
  session?: string,
  regular?: number,
  friendship?: number
): IMenuNavItem[] {
  const settingsItem: IHrefNavItem = {
    ...UserSettingsItem,
    label: LanguageService.getTFunction()(UserSettingsItem.label),
    link: HistoryService.getExternalUrl(ENV.UserAppPath, language, session),
  };
  const personalization: IHrefNavItem = {
    ...personalizationItem,
    label: LanguageService.getTFunction()(personalizationItem.label),
    link: HistoryService.getTrainingUrl(personalizationItem.link, language, session),
  };
  const friendsItem: IHrefNavItem = {
    ...FriendsItem,
    label: LanguageService.getTFunction()(FriendsItem.label),
    link: HistoryService.getFriendsUrl(language, session),
    badge: friendship,
  };
  const messagesItem: IHrefNavItem = {
    ...MessagesItem,
    label: LanguageService.getTFunction()(MessagesItem.label),
    link: HistoryService.getMessagesUrl(language, session),
    badge: regular,
  };
  const logoutItem: IActionNavItem = {
    ...LogoutItem,
    label: LanguageService.getTFunction()(LogoutItem.label),
    onAction: actionHandler,
  };

  return [settingsItem, personalization, friendsItem, messagesItem, logoutItem];
}
